import { Routes, Route } from 'react-router-dom';
import { Toaster, ToastBar, toast } from 'react-hot-toast';

import { ROUTES } from '@/constants';
import { useScrollToTop } from '@/hooks';
import { ModalBase } from '@/components/modals/ModalBase/ModalBase';
import { AppShell } from '@/components/layout/AppShell/AppShell';
import { ProtectedRoute } from '@/components/features/ProtectedRoute/ProtectedRoute';

// Pages
import { Login } from '@/pages/auth/Login/Login';
import { Feed } from '@/pages/Feed/Feed';
import { PollDetail } from '@/pages/PollDetail/PollDetail';
import { CreatePoll } from '@/pages/CreatePoll/CreatePoll';
import { MyPolls } from '@/pages/MyPolls/MyPolls';
import { Profile } from '@/pages/Profile/Profile';
import { Privacy } from '@/pages/Privacy/Privacy';
import { Terms } from '@/pages/Terms/Terms';
import { NotFound } from '@/pages/NotFound/NotFound';
import { FormDetail } from '@/pages/FormDetail/FormDetail';
import { FormResponses } from '@/pages/FormResponses/FormResponses';
import { FormAnalytics } from '@/pages/FormAnalytics/FormAnalytics';
import { FormBuilder } from '@/pages/FormBuilder/FormBuilder';
import { FormShare } from '@/pages/FormShare/FormShare';
import { ResponseDetail } from '@/pages/ResponseDetail/ResponseDetail';

import './App.css';

function App() {
    useScrollToTop();

    return (
        <div className="App">
            <ModalBase />
            <Toaster
                position="top-center"
                toastOptions={{
                    success: { duration: 3000, className: 'toast-success' },
                    error: { duration: 8000, className: 'toast-error' },
                    style: {
                        zIndex: 20,
                    },
                }}
                children={(toasts) => (
                    <ToastBar toast={toasts}>
                        {({ icon, message }) => (
                            <div
                                onClick={() => toast.dismiss()}
                                style={{ cursor: 'pointer', display: 'flex' }}
                            >
                                {icon}
                                {message}
                            </div>
                        )}
                    </ToastBar>
                )}
            />
            <Routes>
                {/* Public auth */}
                <Route path={ROUTES.login} element={<Login />} />

                {/* Public legal pages */}
                <Route path={ROUTES.privacy} element={<Privacy />} />
                <Route path={ROUTES.terms} element={<Terms />} />

                {/* App Shell layout */}
                <Route element={<AppShell />}>
                    {/* Public routes */}
                    <Route path={ROUTES.feed} element={<Feed />} />
                    <Route path={ROUTES.poll} element={<PollDetail />} />
                    <Route path={ROUTES.profile} element={<Profile />} />

                    {/* Form routes (public) */}
                    <Route path={ROUTES.formDetail} element={<FormDetail />} />

                    {/* Form routes (protected — owner-only pages) */}
                    <Route element={<ProtectedRoute redirectToLogin />}>
                        <Route path={ROUTES.formResponses} element={<FormResponses />} />
                        <Route path={ROUTES.formAnalytics} element={<FormAnalytics />} />
                        <Route path={ROUTES.formShare} element={<FormShare />} />
                        <Route path={ROUTES.responseDetail} element={<ResponseDetail />} />
                    </Route>

                    {/* Protected routes */}
                    <Route element={<ProtectedRoute redirectToLogin />}>
                        <Route path={ROUTES.create} element={<CreatePoll />} />
                        <Route path={ROUTES.myPolls} element={<MyPolls />} />
                        <Route path={ROUTES.createForm} element={<FormBuilder />} />
                    </Route>
                </Route>

                <Route path={ROUTES.notFound} element={<NotFound />} />
            </Routes>
        </div>
    );
}

export { App };
